import { KPI } from '../../@core/api';
import { InitiativesService } from './../../@core/utils/initiatives.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'initiativeType',
    standalone: true
})
export class InitiativeTypePipe implements PipeTransform {

  private result: string = '';

  constructor(
    private initiativesService: InitiativesService,
  ) {}

  // Recursive function to get the parent of the initiative type
  // Make it
  private recursiveInitiativeType(
    initiativeTypeId: number,
    initiativeTypes: KPI.InitiativeType[],
    isLastChild = false,
  ): void {
    const initiativeType = initiativeTypes.find((type) => type.id === initiativeTypeId);
    if (!initiativeType) {
      return;
    }
    this.result = initiativeType.name + (!isLastChild ? ' > ' : '') + this.result;
    this.recursiveInitiativeType(initiativeType.parent, initiativeTypes);
  }

  transform(initiativeTypeId: number): string {
    this.initiativesService.initiativeTypes$.subscribe((initiativeTypes) => {
      this.recursiveInitiativeType(initiativeTypeId, initiativeTypes, true);
    });
    return this.result;
  }
}
